import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import auth from '../../common/Auth';
import { PAGEAUTH } from '../../common/AuthConfig';
import { saveMenuAuth } from '../../actions/menuActions';
import { saveTemplateItem, saveTemplateList } from '../../actions/templateActions';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import { CACHE_VERSION } from '../../common/cacheVersion';
import { queryApprovalUserCached } from '../../common/permissionCache';
import './style/layout.less';

const SubMenu = Menu.SubMenu;

// 权限/配置类前端缓存统一 TTL：与后端 queryApprovalUser 的 Redis 缓存口径一致
const CACHE_TTL = 420 * 1000;
// isBlind 模块级缓存（按 invId），页面刷新自动失效，重进项目自动重查
const blindCache = new Map();

class Nav extends Component {
    state = {
        current: '/home',
        showStaffScore: '',
        FINCanViewUserEfficiency: false, // 部分FIN可以查看人员效率
        isShowInvPlan: false,  //是否是执行业务线二级分类为”非盲”且设置了配套盲态项目的项目
        sidebarCollapsed: sessionStorage.getItem('sidebarCollapsed') === 'true',
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    toggleSidebar = () => {
        const newState = !this.state.sidebarCollapsed;
        this.setState({ sidebarCollapsed: newState });
        sessionStorage.setItem('sidebarCollapsed', newState);
        document.body.classList.toggle('sidebar-collapsed', newState);
    }

    getHashUrl = () => {
        const hash = location.hash.substr(1);
        let hashStr = hash;
        if (hash.startsWith("/member/require/")) {
            hashStr = "/member/require"
        } else if (hash.startsWith("/execute/crf/Type_Visit/")) {
            hashStr = "/execute/crf/Type_Visit"
        } else if (hash.startsWith("/execute/transfer/")) {
            hashStr = "/execute/transfer"
        } else if (hash.startsWith("/manHour/write")) {
            hashStr = "/manHour/write"
        } else if (hash.startsWith("/user/transfer/")) {
            hashStr = "/user/transfer"
        } else if (hash.startsWith("/user/require/")) {
            hashStr = "/user/require"
        } else if (hash.startsWith("/invList/")) {
            hashStr = "/invList"
        } else if (hash.startsWith("/execute/manHour/")) {
            hashStr = "/execute/manHour"
        }
        return hashStr;
    }

    checkPageAuth = () => {
        const { siteId, curRole, invId, invState, blindType, investigationSiteName, isClinicalUser } = sessionStorage;
        const isUnBlind = blindType === 'NOTBLIND';       // 非盲项目
        let hashStr = this.getHashUrl();
        let pageAuth = {};
        if (siteId == 0) {
            pageAuth = PAGEAUTH.allSites;
        } else {
            pageAuth = PAGEAUTH.detailSite;
        }
        // 是否进入项目
        if (invId > 0) {
            let shouldChange = false;
            if (hashStr.startsWith('/execute/template')) {
                return;
            }
            if (hashStr.startsWith('/executeMgr/')) {
                if (hashStr.startsWith('/executeMgr/template')) {
                    if (investigationSiteName) {
                        location.href = `./#/execute/${hashStr.slice(12)}`;
                    }
                    return;
                } else {
                    if (investigationSiteName) {
                        shouldChange = true;
                        hashStr = `/execute/${hashStr.slice(12)}`;
                    }
                }
            }
            // 是否有该页面的权限
            if (pageAuth.hasOwnProperty(hashStr)) {
                if (isUnBlind) {
                    if (
                        hashStr.startsWith('/summary/siteStart/') ||
                        hashStr.startsWith('/summary/view/') ||
                        hashStr.startsWith('/startUp/crf/heredity') ||
                        hashStr.startsWith('/startUp/siteStart') ||
                        hashStr.startsWith('/competeCompany/performance') ||
                        hashStr.startsWith('/competeCompany/compare')
                    ) {
                        location.href = `./#/summary/visit/cumVisit`;
                        return;
                    } else if (
                        hashStr.startsWith('/executeMgr/crf/Type_Pre_Filter') ||
                        hashStr.startsWith('/executeMgr/crf/Type_Filter') ||
                        hashStr.startsWith('/executeMgr/crf/Type_SAE') ||
                        hashStr.startsWith('/execute/crf/Type_Pre_Filter') ||
                        hashStr.startsWith('/execute/crf/Type_Filter') ||
                        hashStr.startsWith('/execute/crf/Type_SAE')
                    ) {
                        location.href = `./#/execute/visitPeriodPlan`;
                        return;
                    } else if (
                        hashStr.startsWith('/summary/siteStart/') ||
                        hashStr.startsWith('/summary/view/') ||
                        hashStr.startsWith('/summary/groupingRate') ||
                        hashStr.startsWith('/summary/site/') ||
                        hashStr.startsWith('/summary/groupingRateCompare') ||
                        hashStr.startsWith('/summary/siteGroupingRate')
                    ) {
                        location.href = `./#/summary/visit/cumVisit`;
                        return;
                    } else if (
                        hashStr.startsWith('/summary/siteStart/') ||
                        hashStr.startsWith('/summary/view/') ||
                        hashStr.startsWith('/summary/groupingRate') ||
                        hashStr.startsWith('/summary/site/') ||
                        hashStr.startsWith('/summary/groupingRateCompare') ||
                        hashStr.startsWith('/summary/siteGroupingRate') ||
                        hashStr.startsWith('/summary/preFilter/') ||
                        hashStr.startsWith('/summary/filter')
                    ) {
                        location.href = `./#/summary/visit/cumVisit`;
                        return;
                    }
                    if (
                        (
                            (invState == 1) &&
                            (
                                hashStr.startsWith('/plan/degree') ||
                                hashStr.startsWith('/plan/invStart') ||
                                hashStr.startsWith('/plan/investigation/') ||
                                hashStr.startsWith('/plan/site/')
                            )
                        ) ||
                        (
                            (invState == 2) &&
                            (
                                hashStr.startsWith('/plan/degree') ||
                                hashStr.startsWith('/plan/invStart') ||
                                hashStr.startsWith('/plan/investigation/') ||
                                hashStr.startsWith('/plan/site/') ||
                                hashStr.startsWith('/plan/PmFte') ||
                                hashStr.startsWith('/plan/PaFte')
                            )
                        )
                    ) {
                        location.href = `./#/plan/siteFte`;
                        return;
                    }
                } else {
                    if (
                        hashStr.startsWith('/executeMgr/crf/Type_Drug_Overtemperature') ||
                        hashStr.startsWith('/executeMgr/crf/Type_Drug_Breakage') ||
                        hashStr.startsWith('/executeMgr/crf/Type_Instrument_Certificate') ||
                        hashStr.startsWith('/executeMgr/crf/Type_Drug_Blindness') ||
                        hashStr.startsWith('/executeMgr/crf/Type_Drug_Inventory') ||
                        hashStr.startsWith('/execute/crf/Type_Drug_Overtemperature') ||
                        hashStr.startsWith('/execute/crf/Type_Drug_Breakage') ||
                        hashStr.startsWith('/execute/crf/Type_Instrument_Certificate') ||
                        hashStr.startsWith('/execute/crf/Type_Drug_Blindness') ||
                        hashStr.startsWith('/execute/crf/Type_Drug_Inventory')
                    ) {
                        location.href = `./#/execute/visitPeriodPlan`;
                        return;
                    }
                }
                if (investigationSiteName && (hashStr.startsWith('/invDetails') || hashStr.startsWith('/projectContract/childContract'))) {
                    location.href = `./#/summary/view/cumInfRan`;
                    return;
                }
                if (pageAuth[hashStr][0] == "*") {
                    return;
                }
                if (!pageAuth[hashStr].includes(curRole)) {
                    location.href = `./#/summary/view/cumInfRan`;
                }
                if (shouldChange) {
                    location.href = `./#${hashStr}`;
                }
            } else {
                if (hashStr.startsWith('/personal/file') && isClinicalUser == 'true') {
                    // "我的-个人文件夹"是临床资源部的人可以跳转
                    location.href = `./#/personal/file`;
                } else if (hashStr.startsWith('/fileManagement/projectFile')) {
                    location.href = `./#${hashStr}`;
                } else {
                    location.href = `./#/summary/view/cumInfRan`;
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const { hash } = this.props;
        this.checkPageAuth();
        const hashStr = this.getHashUrl();
        if (nextProps.hash != hash) {
            this.queryApprovalUser();
            this.queryTemplateName();
            this.queryBlindInvestigation();
            const { invName } = sessionStorage;
            if (!invName) {
                this.checkIsSsuMemberAndBO();
            }
        }
        this.setState({ current: hashStr });
    }

    componentWillMount() {
        this.checkPageAuth();
        this.queryApprovalUser();
        this.queryUserAdditionalPermissions();
        this.queryBlindInvestigation();
        const hashStr = this.getHashUrl();
        // 恢复侧边栏状态
        if (sessionStorage.getItem('sidebarCollapsed') === 'true') {
            document.body.classList.add('sidebar-collapsed');
        }
        this.setState({ current: hashStr }, () => {
            this.queryTemplateName();

            const { invName } = sessionStorage;
            if (!invName) {
                this.checkIsSsuMemberAndBO();
            }
        });
    }

    // 查询财务管理权限（仅依赖 userId 的全局配置快照，走共享缓存模块，命中不发请求）
    queryApprovalUser = () => {
        queryApprovalUserCached('FIN_MODULE,TEACH_LEADER', res => this.applyApprovalUser(res));
    }

    applyApprovalUser = (res) => {
        this.props.saveMenuAuth(res);
        const { isInvAreaLeader, isInvPM, isHospitalDirector, haveQuotationMenu, haveEvaluateMenu, isDesignatedTal, isClinicalBO, isClinicalUser, canSuspicious, outInvHaveMajorEvent } = res;
        sessionStorage.isInvAreaLeader = isInvAreaLeader;
        sessionStorage.isInvPM = isInvPM;
        sessionStorage.isHospitalDirector = isHospitalDirector;
        sessionStorage.haveQuotationMenu = haveQuotationMenu;
        sessionStorage.haveEvaluateMenu = haveEvaluateMenu;
        sessionStorage.isDesignatedTal = isDesignatedTal;  //是否领域leader（临床评估记录）
        sessionStorage.isClinicalBO  = isClinicalBO;  //是否是部门BO（临床评估记录）
        sessionStorage.isClinicalUser  = isClinicalUser;  //是否是临床资源部人员
        sessionStorage.canSuspicious = canSuspicious;
        sessionStorage.outInvHaveMajorEvent = outInvHaveMajorEvent;
    }

    // 部分FIN开放人员管理-人员效率
    queryUserAdditionalPermissions = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserAdditionalPermissions,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { list = [] } = res;
                const FINCanViewUserEfficiency = list.some( el => el == 'EMPLOYEE_MANAGER_EMP_EFFICIENCY')
                this.setState({ FINCanViewUserEfficiency })
            },
        };
        $.sendRequest(options);
    }

    // BO/CTA 与后端分支等价（SsuMemberController 按 curRoleCode 判断），前端直接短路；
    // "是否 SSU 成员"仅依赖 userId，按 TTL 缓存
    checkIsSsuMemberAndBO = () => {
        const { curRole } = sessionStorage;
        if (curRole === 'BO' || curRole === 'CTA') {
            sessionStorage.setItem('showStaffScore', 'true');
            this.setState({ showStaffScore: 'true' });
            return;
        }
        const cacheKey = `isSsuMember_${CACHE_VERSION}`;
        let cached = null;
        try {
            cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
        } catch (e) {
            cached = null;
        }
        if (cached && (Date.now() - cached.ts) < CACHE_TTL) {
            sessionStorage.setItem('showStaffScore', cached.v);
            this.setState({ showStaffScore: cached.v });
            return;
        }
        const options = {
            method: 'post',
            url: API_URL.hospital.checkIsSsuMemberAndBO,
            data: {},
            dataType: 'json',
            doneResult: (res => {
                try {
                    sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), v: res.isShowSsuMemberScoreGrade }));
                } catch (e) { /* sessionStorage 不可用时退化为每次请求 */ }
                sessionStorage.setItem('showStaffScore', res.isShowSsuMemberScoreGrade);
                this.setState({ showStaffScore: res.isShowSsuMemberScoreGrade });
            }),
        }
        $.sendRequest(options);
    }

    // 强项目上下文：仅项目内请求；同项目按 invId 缓存（TTL），模块级 Map 页面刷新自动失效
    queryBlindInvestigation = () => {
        const invId = Number(sessionStorage.invId) || 0;
        if (invId <= 0) {
            this.setState({ isShowInvPlan: false });
            return;
        }
        const cached = blindCache.get(invId);
        if (cached && (Date.now() - cached.ts) < CACHE_TTL) {
            this.setState({ isShowInvPlan: cached.isShowInvPlan });
            return;
        }
        const options = {
            method: 'POST',
            url: API_URL.plan.queryBlindInvestigation,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { isBlind, secondLines } = res;
                const isShowInvPlan = isBlind && secondLines === '非盲';
                blindCache.set(invId, { ts: Date.now(), isShowInvPlan });
                this.setState({
                    isShowInvPlan,
                });
            },
        };
        $.sendRequest(options);
    }

    queryTemplateName = () => {
        const _this = this;
        setTimeout(function () {
            const { invState } = sessionStorage;
            if (invState == 0) {
                return;
            }
            const options = {
                method: 'post',
                url: API_URL.execute.queryPortalFollowBoardList,
                data: {
                    startUpStatus: '',
                    investigationId: sessionStorage.invId,
                },
                dataType: 'json',
                doneResult: (res => {
                    if (!res.error && _this.props) {
                        const { selectItem } = _this.props;
                        const { followBoardId } = selectItem;
                        const isExist = res.followBoardList.some(item => item.followBoardId == followBoardId);
                        const hash = location.hash.substr(1);
                        if (!isExist) {
                            if (hash.startsWith('/executeMgr/template')) {
                                location.href = './#/executeMgr/visitPeriodPlan';
                            } else if (hash.startsWith('/execute/template')) {
                                location.href = './#/execute/visitPeriodPlan';
                            }
                        }
                        _this.props.templateListCreator(res.followBoardList);
                    }
                }),
            }
            $.sendRequest(options);
        }, 300);
    }

    saveTemplateId = (index) => {
        const { templateList, templateItemCreator } = this.props;
        templateItemCreator(templateList[index]);
    }

    getTemplateNameList = (type) => {
        const { templateList } = this.props;
        let templateNameList;
        if (type == 'execute') {
            templateNameList = templateList.map((item, index) => {
                if (item.startUpStatus == 'ACTIVE') {
                    return (
                        <Menu.Item key={`/${type}/template/${item.patientTypeName || item.noPatientTypeName}`}>
                            <a
                                href={`#/${type}/template/${item.patientTypeName || item.noPatientTypeName}`}
                                onClick={() => this.saveTemplateId(index)}
                            >{item.followBoardName}</a>
                        </Menu.Item>
                    )
                }
            });
        } else {
            templateNameList = templateList.map((item, index) =>
                <Menu.Item key={`/${type}/template/${item.patientTypeName || item.noPatientTypeName}`}>
                    <a
                        href={`#/${type}/template/${item.patientTypeName || item.noPatientTypeName}`}
                        onClick={() => this.saveTemplateId(index)}
                    >{item.followBoardName}</a>
                </Menu.Item>
            );
        }
        return templateNameList;
    }

    // CTA,  //系统管理员
    // VP,   //副总裁
    // FIN,  //财务
    // EA,   //企业管理员
    // BO,   //总监
    // BDO,  //BD总监
    // BD,
    // PA,   //项目管理员
    // PM,   //项目经理
    // CRCC, //CRC主管
    // CRCM, //CRC经理
    // CRC,  //临床协调员
    // CPM,  //客户项目经理
    // PI,   //研究者
    // CRA,  //监察员
    // OTH,  //其它

    render() {
        const { curRole, curEmployeeCode, blindType, invState, positionName } = sessionStorage;
        const isCRC = curRole == 'CRC';
        const isCRCC = curRole == 'CRCC';
        const isPM = curRole == 'PM';
        const isCRCM = curRole == 'CRCM';
        const isBO = curRole == 'BO';
        const isBD = curRole == 'BD';
        const isTAL = curRole == 'TAL';
        const isBDO = curRole == 'BDO';
        const isBDM = curRole == 'BDM';
        const isPA = curRole == 'PA';
        const isCTA = curRole == 'CTA';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isBA = curRole == 'BA';
        const isBAL = curRole == 'BAL';
        const isPML = curRole == 'PML';
        const isCSA = curRole == 'CSA';
        const isCSAL = curRole == 'CSAL';
        const isHRRC = curRole == 'HRRC';
        const isAssistantDirBo = curRole == 'BO' && (positionName == '助理主任' || positionName == '助理总监');
        const { menuAuth } = this.props;
        const { showStaffScore, FINCanViewUserEfficiency, isShowInvPlan } = this.state;
        const { FIN_MODULE, TEACH_LEADER,INV_ABNORMAL_ROLE,INV_ABNORMAL_USER, isHospitalDirector, isInvAreaLeader, isInvPM ,isChargeArea = false, 
            haveQuotationWorkUnitPrice, haveQuotationMenu, haveEvaluateMenu, haveStandardVisitUnitPriceMenu, isDesignatedTal, isClinicalBO, 
            additionalMenuList, outInvHaveMajorEvent = false, isSeniorUserBo, isLineCharge, FINANCE_INCOME_REPORT_USER, FINANCE_ADVANCE_PAYMENT, 
            FINANCE_ORDER_IN_HAND_CHANGE, FINANCE_INV_ABNORMAL, FINANCE_SITE_INCOME, areaChargeUser } = menuAuth;
        const showFinance = !(isVP || isFIN || isPML || isInvAreaLeader || isHRRC || isSeniorUserBo || isDesignatedTal || isLineCharge || areaChargeUser
            || FINANCE_INCOME_REPORT_USER || FINANCE_ADVANCE_PAYMENT || FINANCE_ORDER_IN_HAND_CHANGE
            || FINANCE_INV_ABNORMAL || FINANCE_SITE_INCOME        ) ?
        (FIN_MODULE || []).some(i => i == curEmployeeCode) : true;
        const showTeaching = isPM ? (TEACH_LEADER || []).some(i => i == curEmployeeCode) : true;
        const showTeachingDirector = isCRC ? (TEACH_LEADER || []).some(i => i == curEmployeeCode) : true;
        const isUnBlind = blindType === 'NOTBLIND';       // 非盲项目
        const showFinancialAnomalyReport = ((INV_ABNORMAL_ROLE&&INV_ABNORMAL_ROLE.includes(curRole)==true)
        ||(INV_ABNORMAL_USER&&INV_ABNORMAL_USER.includes(curEmployeeCode)==true)); 
		const showContractModuleForCRC = isInvPM && (isCRC || isCRCC || isCRCM);
        const showAdditionalTeaching = (additionalMenuList || []).some(el => el.menuKey == 'TRAINING_MANAGEMENT_LIST');
        return (
            <nav className="nav-bar">
                <div className="wrapper">
                    <div className="sidebar-toggle-btn" onClick={this.toggleSidebar}>
                        <span>{this.state.sidebarCollapsed ? '☰ 展开菜单' : '✕ 收起菜单'}</span>
                    </div>
                    <Menu
                        onClick={this.handleClick}
                        selectedKeys={[this.state.current]}
                        mode="horizontal"
                    >
                        {
                            /* 首页、临床项目*/
                            auth('role', ['PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'BD', 'BDO', 'BDM', 'CTA', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL', 'HRRC'], 0)(
                                <Menu.Item key="/home"><a href="#/home"><i className="icon iconfont">&#xe644;</i>首页</a></Menu.Item>
                            )
                        }
                        {
                            /* 首页、临床项目*/
                            auth('role', ['PA', 'PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'BD', 'BDO', 'BDM', 'CTA', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL', 'HRRC'], 0)(
                                <Menu.Item key="/invList"><a href="#/invList"><i className="icon iconfont">&#xe782;</i>临床项目</a></Menu.Item>
                            )
                        }
                        {
                            /* 工时记录*/
                            auth('role', ['PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'CTA', 'VP', 'FIN', 'PML', 'HRRC'], 0)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe629;</i>工时记录</span>}>
                                    {
                                        (isPM || isCRC || isCRCC || isCRCM || isPML) && <Menu.Item key="/manHour/write"><a href="#/manHour/write">填写工时</a></Menu.Item>
                                    }
                                    {
                                        (isPM || isCRC || isCRCC || isCRCM || isPML) && <Menu.Item key="/manHour/myHour"><a href="#/manHour/myHour">我的工时</a></Menu.Item>
                                    }
                                    {
                                        (isPM || isCRC || isCRCC || isCRCM || isPML) && <Menu.Item key="/manHour/monthlyFte"><a href="#/manHour/monthlyFte">月度FTE</a></Menu.Item>
                                    }
                                    {
                                        (isPM || isCRC || isCRCC || isCRCM || isPML) && <Menu.Item key="/manHour/myWeekly"><a href="#/manHour/myWeekly">我的周报</a></Menu.Item>
                                    }
                                    {
                                        (isPM || isCRC || isCRCC || isPML) && <Menu.Item key="/manHour/myEfficiency"><a href="#/manHour/myEfficiency">我的效率</a></Menu.Item>
                                    }
                                    {
                                        (isPM || isCRCC || isCRCM || isBO || isCTA || isVP || isFIN || isPML || isHRRC) && <Menu.Item key="/manHour/query"><a href="#/manHour/query">工时查询</a></Menu.Item>
                                    }
                                    {
                                        (isBO || isCTA || isVP || isFIN || isHRRC) && <Menu.Item key="/manHour/report"><a href="#/manHour/report">工时报告</a></Menu.Item>
                                    }
                                    {
                                        (isPM || isBO || isCRCC || isCRCM || isCRC || isCTA || isPML) && <Menu.Item key="/manHour/confirm"><a href="#/manHour/confirm">待确认工时</a></Menu.Item>
                                    }
                                    {
                                        (isBO || isInvAreaLeader) && <Menu.Item key="/manHour/unconfirmProManhour"><a href="#/manHour/unconfirmProManhour">未确认工时项目清单</a></Menu.Item>
                                    }
                                </SubMenu>
                            )
                        }
                        {
                            /* 人员管理*/
                            ((isCRC && isChargeArea) || !isCRC) &&
                            auth('role', ['CRCC', 'CRCM', 'BO', 'PM', 'CTA', 'VP', 'FIN', 'PML', 'BD', 'BDO', 'BDM', 'HRRC', 'CSAL', 'BAL'], 0)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe648;</i>人员管理</span>}>
                                    <SubMenu title={'人员数据'}>
                                        { (!(isBD || isBDM || isCRC) || (isCRC && isChargeArea)) && <Menu.Item key="/user/userInfo"><a href="#/user/userInfo">人员信息</a></Menu.Item> }
                                        {!isFIN && !(isCRC || isBD || isBDM ||isBDO || isHRRC || isBAL) &&<Menu.Item key="userResume"><a href="#/user/userResume">人员简历</a></Menu.Item>}
                                        {(isBO || isPML || isCRCM || isCRCC || isCSAL) && <Menu.Item key="userFolder"><a href="#/user/userFolder">人员文件夹</a></Menu.Item>}
                                        {!isFIN && !(isCRC || isBD || isBDM || isHRRC) && <Menu.Item key="/user/userPlan"><a href="#/user/userPlan">人员安排</a></Menu.Item>}
                                        {!isPML && !(isCRC || isBD || isBDO || isBDM || isHRRC || isBAL) && <Menu.Item key="/user/require"><a href="#/user/require">人员需求</a></Menu.Item> }
                                        {!isPML && !isCRC && !isHRRC && !isBAL && <Menu.Item key="/user/transfer"><a href="#/user/transfer">人员交接</a></Menu.Item> }
                                        {(isBO || isCSAL || isVP || isCRCC || isCRCM || isInvAreaLeader || isInvPM || isPML) && <Menu.Item key="/user/userDimission"><a href="#/user/userDimission">人员离职</a></Menu.Item>}
                                        {(isBO || isCSAL || isCTA || isVP || isFIN || isPML || isHRRC) && <Menu.Item key="/user/userManhour"><a href="#/user/userManhour">人员工时</a></Menu.Item>}
                                        {!isFIN && !isHRRC && !isBAL && <Menu.Item key="/user/pmTransfer"><a href="#/user/pmTransfer">PM交接</a></Menu.Item>}
                                        {(isBO || isCSAL || isCTA || isPML) && <Menu.Item key="/user/DashedReport"><a href="#/user/DashedReport">PM虚线汇报线</a></Menu.Item>}
                                        {(isBO || isCSAL || isHRRC || isBDO || isBAL) && <Menu.Item key="/user/fieldLeader"><a href="#/user/fieldLeader">领域leader</a></Menu.Item>}
                                        {!isCRC && !isHRRC && !isBAL && <Menu.Item key="/user/UserDistribution"><a href="#/user/UserDistribution">人员分布</a></Menu.Item>}
                                        { !(isCRC || isCRC || isBD || isBDO || isBDM || isHRRC || isBAL) && <Menu.Item key="/user/UserAnalysis"><a href="#/user/UserAnalysis">人员分析</a></Menu.Item> }
                                    </SubMenu>
                                    {(!isBAL && !isBDO) && <SubMenu title={'效率数据'}>
                                        {(isFIN ? FINCanViewUserEfficiency : (!(isBD || isBDO || isBDM || isCRC) || (isCRC && isChargeArea))) && <Menu.Item key="/user/userEfficiency"><a href="#/user/userEfficiency">人员效率</a></Menu.Item>}
                                        {(isFIN ? FINCanViewUserEfficiency : (!(isBD || isBDO || isBDM || isCRC) || (isCRC && isChargeArea))) && <Menu.Item key="/user/UserOutput"><a href="#/user/UserOutput">人员产出率</a></Menu.Item>}
                                        {(isFIN ? FINCanViewUserEfficiency : (isBO || isCSAL || isCTA || isPM || isCRCC || isCRCM || isVP || isPML)) && <Menu.Item key="/user/areaCityAnalysis"><a href="#/user/areaCityAnalysis">区域城市分析</a></Menu.Item>}
                                    </SubMenu>}
                                    {(!isBAL && !isBDO) && <SubMenu title={'绩效数据'}>
                                        {(isVP || isBO || isCSAL || isCRCC || isCRCM || isHRRC) && <Menu.Item key="/user/crcPostRank"><a href="#/user/crcPostRank">CRC岗位排名</a></Menu.Item>}
                                        {(isCRCC || isCRCM || isBO || isCSAL || isPML || isPM) && <Menu.Item key="/user/crcTeamContributeScore"><a href="#/user/crcTeamContributeScore">CRC团队贡献度</a></Menu.Item>}
                                        {(isBO || isCSAL || isCRCC || isCRCM) && <Menu.Item key="/user/teamManageEvaluate"><a href="#/user/teamManageEvaluate">团队管理评价</a></Menu.Item>}
                                        {(isBO || isCSAL || isPML) && <Menu.Item key="/user/pmInfo"><a href="#/user/pmInfo">PM信息</a></Menu.Item>}
                                    </SubMenu>}
                                </SubMenu>
                            )
                        }
                        {
                            /* 质量管理 */
                            (((isCRC && isInvPM) || !isCRC) || outInvHaveMajorEvent) &&
                            auth('role', ['VP', 'BO', 'CRCC', 'CRCM', 'PM', 'PML','CTA','CRC', 'HRRC','CSA','CSAL'], 0)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe62f;</i>质量管理</span>}>
                                    { outInvHaveMajorEvent && <Menu.Item key="/qualityManagement/importantEvent"><a href="#/qualityManagement/importantEvent">重大事件</a></Menu.Item>}
                                    { (!isCRC && !isCSA && !isCSAL) &&<Menu.Item key="/qualityManagement/complaintRegistrationForm"><a href="#/qualityManagement/complaintRegistrationForm">投诉登记表</a></Menu.Item>}
                                    {(isVP || isCTA || isBO || isPML || isPM || (isCRC && isInvPM) || isCRCC || isCRCM || isHospitalDirector || isCSA || isCSAL ) &&<Menu.Item key="/qualityManagement/nationalVerification"><a href="#/qualityManagement/nationalVerification">国家核查汇总</a></Menu.Item>}
                                    {(isVP || isCTA || isBO || isPML || isPM || (isCRC && isInvPM) || isCRCC || isCRCM || isCSA || isCSAL ) &&<Menu.Item key="/qualityManagement/ImportantMilestone"><a href="#/qualityManagement/ImportantMilestone">重要里程碑和上市登记</a></Menu.Item>}
                                </SubMenu>
                            )
                        }
                        {
                            /* 医院档案*/
                            auth('role', ['PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'BD', 'BDO', 'BDM', 'CTA', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL', 'HRRC'], 0)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe600;</i>医院档案</span>}>
                                    <Menu.Item key="/hospital/detail"><a href="#/hospital/detail">医院信息</a></Menu.Item>
                                    <Menu.Item key="/hospital/departmentDetail"><a href="#/hospital/departmentDetail">医院科室信息</a></Menu.Item>
                                    <Menu.Item key="/hospital/doctor"><a href="#/hospital/doctor">医生信息</a></Menu.Item>
                                    <Menu.Item key="/hospital/filingInfo"><a href="#/hospital/filingInfo">医院机构备案信息</a></Menu.Item>
                                    {
                                    !isHRRC && <Menu.Item key="/hospital/ssu"><a href="#/hospital/ssu">SSU通讯录</a></Menu.Item>
                                    }
                                    {(isBO || isCTA) && <Menu.Item key="/hospital/staffing"><a href="#/hospital/staffing">SSU人员安排</a></Menu.Item>}
                                    {showStaffScore == 'true' && <Menu.Item key="/hospital/staffScore"><a href="#/hospital/staffScore">SSU人员评分</a></Menu.Item>}
                                </SubMenu>                                                                                             
                            )
                        }
                        {
                            auth('role', ['PA', 'PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'BD', 'BDO', 'BDM', 'CTA', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 0)(
                                <Menu.Item key="/siteComment"><a href="#/siteComment"><i className="icon iconfont">&#xe675;</i>研究中心推荐</a></Menu.Item>
                            )
                        }
                        {
                            (showAdditionalTeaching && invState == 0) &&
                            <SubMenu title={<span><i className="icon iconfont">&#xe8fe;</i>带教管理</span>}>
                                <Menu.Item key="/teaching/management"><a href="#/teaching/management">带教管理</a></Menu.Item> 
                            </SubMenu>
                        }
                        {
                            auth('role', ['BO', 'CRC', 'CRCC', 'CRCM', 'PM', 'HRRC'], 0)(
                                showTeaching &&
                                <SubMenu title={<span><i className="icon iconfont">&#xe8fe;</i>带教管理</span>}>
                                    { showTeachingDirector && <Menu.Item key="/teaching/director"><a href="#/teaching/director">带教负责人</a></Menu.Item> }
                                    { showTeachingDirector && <Menu.Item key="/teaching/management"><a href="#/teaching/management">带教管理</a></Menu.Item> }
                                    { isCRC && <Menu.Item key="/teaching/qualityAssessmentSheet"><a href="#/teaching/qualityAssessmentSheet">带教质量评估表</a></Menu.Item> }
                                </SubMenu>
                            )
                        }
                        {
                            (isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || isInvAreaLeader || isInvPM || showContractModuleForCRC || isCRCC || isCRCM || isHRRC || isPA || isCRC) &&  invState == 0 &&
                            <SubMenu title={<span><i className="icon iconfont">&#xe64e;</i>合同管理</span>}>
                                {(isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || showContractModuleForCRC || isCRCC || isCRCM ) &&
                                <Menu.Item key="/contractManagement/contractRecord"><a href="#/contractManagement/contractRecord">合同记录</a></Menu.Item>}
                                {(isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || showContractModuleForCRC || isCRCC || isCRCM) && 
                                <Menu.Item key="/contractManagement/requestRecord"><a href="#/contractManagement/requestRecord">合同请款记录</a></Menu.Item>}
                                {(isBO || isCTA || isVP || isPML || isInvAreaLeader || isInvPM  || isBAL || isBA || isCSA || isCSAL || isFIN || isCRCC || isCRCM) && 
                                <Menu.Item key="/contractManagement/coFollowFunds"><a href="#/contractManagement/coFollowFunds">CO跟进和请款预计</a></Menu.Item>}
                                { (isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || showContractModuleForCRC || isCRCC || isCRCM || isHRRC) && 
                                <Menu.Item key="/contractManagement/returnedMoney"><a href="#/contractManagement/returnedMoney">发票和回款记录</a></Menu.Item>}
                                { (isVP || isFIN || isBO || isCSAL || isPML || isPM || isCSA || isInvAreaLeader || isInvPM ) && 
                                <Menu.Item key="/contractManagement/ptReimburse"><a href="#/contractManagement/ptReimburse">PT费用报销记录</a></Menu.Item>}
                                {(isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || showContractModuleForCRC || isCRCC || isCRCM) && 
                                <Menu.Item key="/contractManagement/identificationCode"><a href="#/contractManagement/identificationCode">项目识别码</a></Menu.Item>}
                                { (isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || showContractModuleForCRC || isCRCC || isCRCM) && 
                                <Menu.Item key="/contractManagement/applyJdeCode"><a href="#/contractManagement/applyJdeCode">JDE建号申请记录</a></Menu.Item>}
                                { (isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || showContractModuleForCRC || isCRCC || isCRCM) && 
                                <Menu.Item key="/contractManagement/contractInfoChange"><a href="#/contractManagement/contractInfoChange">合同信息变更申请</a></Menu.Item>}
                                { (isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isPML || isCSA || isCSAL ||showContractModuleForCRC || isCRCC || isCRCM) && 
                                <Menu.Item key="/contractManagement/alterJdeCode"><a href="#/contractManagement/alterJdeCode">JDE主项目号变更申请</a></Menu.Item>}
                                { (isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || showContractModuleForCRC || isCRCC || isCRCM) && 
                                <Menu.Item key="/contractManagement/terminationApply"><a href="#/contractManagement/terminationApply">项目终止申请</a></Menu.Item>}
                                {(isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCRCC || isCRCM) && isFIN && 
                                <Menu.Item key="/contractManagement/currencyExchangeRate"><a href="#/contractManagement/currencyExchangeRate">币种汇率</a></Menu.Item>}
                                { (isBO || isBDO || isBDM || isPM || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || isCRCC || isCRCM) &&
                                <Menu.Item key="/contractManagement/responseCustomer"><a href="#/contractManagement/responseCustomer">负责客户清单</a></Menu.Item>}
                                { (isBA || isBD || isBDO || isBAL || isBDM) &&
                                <Menu.Item key="/contractManagement/crmContractRecord"><a href="#/contractManagement/crmContractRecord">CRM合同记录</a></Menu.Item>}

                                {isFIN && <Menu.Item key="/contractManagement/activityitem"><a href="#/contractManagement/activityitem">活动项目代码表</a></Menu.Item>}
                                { (isVP || isBO || isPM || isPA || isCRCC || isCRCM || isPML || isCRC || isCSA || isCSAL) &&
                                <Menu.Item key="/contractManagement/crcAgreeReportSummary"><a href="#/contractManagement/crcAgreeReportSummary">CRC协议报表汇总</a></Menu.Item>}
                            </SubMenu>
                        }
                        {
                            auth('role', ['PA', 'PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'BD', 'BDO', 'CTA', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL', 'HRRC'], 0)(
                                (showFinance || isCRCC || isCRCM || isAssistantDirBo) &&
                                <SubMenu title={<span><i className="icon iconfont">&#xe7e4;</i>财务管理</span>}>
                                    {
                                        (isFIN || isSeniorUserBo || isLineCharge || FINANCE_INCOME_REPORT_USER || isDesignatedTal) &&
                                        <Menu.Item key="/financeManagement/financeIncomeReport"><a href="#/financeManagement/financeIncomeReport">财务收入报告</a></Menu.Item>
                                    }
                                    {
                                        (isFIN || FINANCE_ADVANCE_PAYMENT) && <Menu.Item key="/financeManagement/otherChargesReport"><a href="#/financeManagement/otherChargesReport">代垫费用收入报告</a></Menu.Item>
                                    }
                                    {
                                        (isFIN || isSeniorUserBo || FINANCE_ORDER_IN_HAND_CHANGE || isDesignatedTal) && <Menu.Item key="/financeManagement/orderChangeReport"><a href="#/financeManagement/orderChangeReport">在手订单额变动报告</a></Menu.Item>
                                    }
                                    {(isFIN || isSeniorUserBo || FINANCE_INV_ABNORMAL || isDesignatedTal)&&
                                    <Menu.Item key="/financeManagement/financialAnomalyReport"><a href="#/financeManagement/financialAnomalyReport">服务费收入异常报告</a></Menu.Item>
                                    }
                                    {
                                        (isFIN || isCRCC || isCRCM || isSeniorUserBo || FINANCE_SITE_INCOME || isDesignatedTal || isLineCharge || areaChargeUser || isAssistantDirBo) && <Menu.Item key="/financeManagement/centerIncomeReport"><a href="#/financeManagement/centerIncomeReport">中心收入报告</a></Menu.Item>
                                    }
                                    {isFIN &&
                                    <Menu.Item key="/financeManagement/collectReport"><a href="#/financeManagement/collectReport">应收账款表</a></Menu.Item>
                                    }
                                    {(isFIN || isBO || isHRRC || isCRCC || isCRCM ) &&
                                    <Menu.Item key="/financeManagement/IncomeReport"><a href="#/financeManagement/IncomeReport">个人收入报告</a></Menu.Item>
                                    }
                                    {isFIN && <Menu.Item key="/financeManagement/incomestatement"><a href="#/financeManagement/incomestatement">收入报表</a></Menu.Item>}
                                </SubMenu>
                            )
                        }
                        {
                            auth('role', ['VP', 'BO', 'FIN', 'PML', 'PM', 'BDM', 'BDO', 'BD', 'BA', 'BAL', 'CSA', 'CSAL','CRC','CRCC','CRCM'], 0)(
                                (isInvAreaLeader || haveEvaluateMenu || haveStandardVisitUnitPriceMenu) &&
                                <SubMenu title={<span><i className="icon iconfont">&#xe8cd;</i>临床评估</span>}>
                                    {haveStandardVisitUnitPriceMenu && <Menu.Item key="/clinicalEvaluation/standardVisitPrice"><a href="#/clinicalEvaluation/standardVisitPrice">标准访视单价</a></Menu.Item>}
                                    {(isDesignatedTal || isClinicalBO) && <Menu.Item key="/clinicalEvaluation/VisitingHours"><a href="#/clinicalEvaluation/VisitingHours">访视工时</a></Menu.Item>}
                                    {haveEvaluateMenu && <Menu.Item key="/clinicalEvaluation/clinicalEvaluationRecord"><a href="#/clinicalEvaluation/clinicalEvaluationRecord">临床评估记录</a></Menu.Item>}
                                </SubMenu>
                            )
                        }

                        {
                            /* 文件管理*/
                            auth('role', ['PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'BD', 'BDO', 'BDM', 'CTA', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL', 'HRRC'], 0)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe8cd;</i>文件管理</span>}>
                                    <Menu.Item key="/documentManagement/departmentalDocuments">
                                        <a href="#/documentManagement/departmentalDocuments">部门文档</a>
                                    </Menu.Item>
                                </SubMenu>
                            )
                        }

                        {
                            auth('role', ['VP', 'BO', 'FIN', 'PML', 'PM', 'BDM', 'BDO', 'BD', 'BA', 'BAL', 'CSA', 'CSAL','CRC','CRCC','CRCM'], 0)(
                                (haveQuotationMenu || haveQuotationWorkUnitPrice) &&
                                <SubMenu title={<span><i className="icon iconfont">&#xe632;</i>商务报价</span>}>
                                    {haveQuotationMenu && <Menu.Item key="/businessOffer/businessOfferRecord"><a href="#/businessOffer/businessOfferRecord">商务报价记录</a></Menu.Item>}
                                    {haveQuotationWorkUnitPrice && <Menu.Item key="/businessOffer/taskUnitPrice"><a href="#/businessOffer/taskUnitPrice">工作任务单价</a></Menu.Item>}
                                    {haveQuotationWorkUnitPrice && <Menu.Item key="/businessOffer/siteStartServiceFeePercent"><a href="#/businessOffer/siteStartServiceFeePercent">中心启动服务费用占比</a></Menu.Item>}
                                    {haveQuotationWorkUnitPrice && <Menu.Item key="/businessOffer/businessVisitingHours"><a href="#/businessOffer/businessVisitingHours">访视工时</a></Menu.Item>}
                                </SubMenu>
                            )
                        }
                        {/* {
                            auth('role', ['BD', 'BDM', 'BDO', 'VP', 'BA', 'BAL'], 0, 'quotation')(
                                <Menu.Item key="/quotation"><a href="#/quotation/list"><i className="icon iconfont">&#xe632;</i>项目报价</a></Menu.Item>
                            )
                        } */}
                        {
                            /* 项目信息*/
                            auth('role', ['PA', 'PM', 'CTA'], 3)(
                                <Menu.Item key="/invDetails"><a href="#/invDetails">项目信息</a></Menu.Item>
                            )
                        }
                        {
                            /* 项目计划*/
                            !isUnBlind &&
                            auth('role', ['PA', 'PM', 'CTA'], 3)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe639;</i>项目计划</span>}>
                                    <Menu.Item key="/plan/degree"><a href="#/plan/degree">项目阶段进度计划</a></Menu.Item>
                                    <Menu.Item key="/plan/siteStart"><a href="#/plan/siteStart">各中心启动计划</a></Menu.Item>
                                    <Menu.Item key="/plan/investigation"><a href="#/plan/investigation">项目执行计划</a></Menu.Item>
                                    <Menu.Item key="/plan/site"><a href="#/plan/site">各中心执行计划</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 研究中心*/
                            auth('role', ['PA', 'PM', 'CTA'], 3)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe6b2;</i>研究中心</span>}>
                                    <Menu.Item key="/site/detail"><a href="#/site/detail">研究中心信息</a></Menu.Item>
                                    <Menu.Item key="/site/pi"><a href="#/site/pi">参与临床试验人员信息</a></Menu.Item>
                                    <Menu.Item key="/site/cra"><a href="#/site/cra">CRA信息</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目成员*/
                            auth('role', ['PA', 'PM', 'CTA'], 3)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe73c;</i>项目成员</span>}>
                                    <Menu.Item key="/member/crc"><a href="#/member/crc">CRC信息</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目执行管理端*/
                            auth('role', ['PA', 'PM', 'CTA'], 3)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe702;</i>项目执行</span>}>
                                    <Menu.Item key="/executeMgr/visitPeriodPlan"><a href="#/executeMgr/visitPeriodPlan">访视周期计划</a></Menu.Item>
                                    { !isUnBlind && <Menu.Item key="/executeMgr/crf/Type_Pre_Filter"><a href="#/executeMgr/crf/Type_Pre_Filter">预筛记录</a></Menu.Item> }
                                    { !isUnBlind && <Menu.Item key="/executeMgr/crf/Type_Filter"><a href="#/executeMgr/crf/Type_Filter">筛选记录</a></Menu.Item> }
                                    <Menu.Item key="/executeMgr/crf/Type_Visit"><a href="#/executeMgr/crf/Type_Visit">访视记录其他字段</a></Menu.Item>
                                    <Menu.Item key="/executeMgr/crf/Type_Drop"><a href="#/executeMgr/crf/Type_Drop">退出记录</a></Menu.Item>
                                    <Menu.Item key="/executeMgr/Violation"><a href="#/executeMgr/Violation">方案违背</a></Menu.Item>
                                    { !isUnBlind && <Menu.Item key="/executeMgr/crf/Type_SAE"><a href="#/executeMgr/crf/Type_SAE">SAE记录</a></Menu.Item> }
                                    <Menu.Item key="/executeMgr/qa"><a href="#/executeMgr/qa">Q&A记录</a></Menu.Item>
                                    { isUnBlind && <Menu.Item key="/executeMgr/crf/Type_Drug_Overtemperature"><a href="#/executeMgr/crf/Type_Drug_Overtemperature">药物超温</a></Menu.Item> }
                                    { isUnBlind && <Menu.Item key="/executeMgr/crf/Type_Drug_Breakage"><a href="#/executeMgr/crf/Type_Drug_Breakage">药物破损</a></Menu.Item> }
                                    { isUnBlind && <Menu.Item key="/executeMgr/crf/Type_Instrument_Certificate"><a href="#/executeMgr/crf/Type_Instrument_Certificate">仪器设备校准证书</a></Menu.Item> }
                                    { isUnBlind && <Menu.Item key="/executeMgr/crf/Type_Drug_Blindness"><a href="#/executeMgr/crf/Type_Drug_Blindness">药物破盲</a></Menu.Item> }
                                    { isUnBlind && <Menu.Item key="/executeMgr/crf/Type_Drug_Inventory"><a href="#/executeMgr/crf/Type_Drug_Inventory">药物库存量</a></Menu.Item> }
                                    {this.getTemplateNameList('executeMgr')}
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目合同*/
                            auth('role', ['PA', 'PM', 'CTA'], 3)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe64e;</i>项目合同</span>}>
                                    <Menu.Item key="/projectContract/mainContract"><a href="#/projectContract/mainContract">主合同记录</a></Menu.Item>
                                    <Menu.Item key="/projectContract/childContract"><a href="#/projectContract/childContract">子合同记录</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目状态*/
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'CRCM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe60d;</i>项目状态</span>}>
                                    {
                                        !isUnBlind &&
                                        <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>中心启动情况&nbsp;&nbsp;&nbsp;</span>}>
                                            <Menu.Item key="/summary/siteStart/Project_Approval"><a href="#/summary/siteStart/Project_Approval">立项</a></Menu.Item>
                                            <Menu.Item key="/summary/siteStart/EC_Submit"><a href="#/summary/siteStart/EC_Submit">EC递交</a></Menu.Item>
                                            <Menu.Item key="/summary/siteStart/EC_MEETING"><a href="#/summary/siteStart/EC_MEETING">EC会议</a></Menu.Item>
                                            <Menu.Item key="/summary/siteStart/EC_Approvals"><a href="#/summary/siteStart/EC_Approvals">EC批件</a></Menu.Item>
                                            <Menu.Item key="/summary/siteStart/Letter_Of_Commitment_Collection"><a href="#/summary/siteStart/Letter_Of_Commitment_Collection">承诺书收集</a></Menu.Item>
                                            <Menu.Item key="/summary/siteStart/Final_Contract"><a href="#/summary/siteStart/Final_Contract">合同定稿</a></Menu.Item>
                                            <Menu.Item key="/summary/siteStart/Contract_Signing"><a href="#/summary/siteStart/Contract_Signing">合同签署</a></Menu.Item>
                                            <Menu.Item key="/summary/siteStart/Start_Work_All_Ready"><a href="#/summary/siteStart/Start_Work_All_Ready">启动工作全部ready</a></Menu.Item>
                                            <Menu.Item key="/summary/siteStart/Startup_Meeting_Completed"><a href="#/summary/siteStart/Startup_Meeting_Completed">启动会完成</a></Menu.Item>
                                        </SubMenu>
                                    }
                                    {
                                        !isUnBlind ?
                                            <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>入组情况</span>}>
                                                <Menu.Item key="/summary/view/cumInfRan"><a href="#/summary/view/cumInfRan">累计知情随机(入组)</a></Menu.Item>
                                                <Menu.Item key="/summary/view/monInfRam"><a href="#/summary/view/monInfRam">每月知情随机(入组)</a></Menu.Item>
                                                <Menu.Item key="/summary/view/cumFilRan"><a href="#/summary/view/cumFilRan">累计筛选随机(入组)</a></Menu.Item>
                                                <Menu.Item key="/summary/view/monFilRan"><a href="#/summary/view/monFilRan">每月筛选随机(入组)</a></Menu.Item>
                                                <Menu.Item key="/summary/visit/cumVisit"><a href="#/summary/visit/cumVisit">累计完成访视</a></Menu.Item>
                                                <Menu.Item key="/summary/visit/monVisit"><a href="#/summary/visit/monVisit">每月完成访视</a></Menu.Item>
                                                <Menu.Item key="/summary/groupingRate"><a href="#/summary/groupingRate">入组速率趋势</a></Menu.Item>
                                                <Menu.Item key="/summary/site/siteInformed"><a href="#/summary/site/siteInformed">各中心知情情况</a></Menu.Item>
                                                <Menu.Item key="/summary/site/siteFilter"><a href="#/summary/site/siteFilter">各中心筛选情况</a></Menu.Item>
                                                <Menu.Item key="/summary/site/siteRandom"><a href="#/summary/site/siteRandom">各中心随机(入组)情况</a></Menu.Item>
                                                <Menu.Item key="/summary/groupingRateCompare"><a href="#/summary/groupingRateCompare">各中心入组速率对比</a></Menu.Item>
                                                <Menu.Item key="/summary/siteGroupingRate"><a href="#/summary/siteGroupingRate">各中心入组速率趋势</a></Menu.Item>
                                                <Menu.Item key="/summary/standardVisitHourCompare"><a href="#/summary/standardVisitHourCompare">各中心标访工时数对比</a></Menu.Item>
                                            </SubMenu>
                                        :
                                            <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>入组情况</span>}>
                                                <Menu.Item key="/summary/visit/cumVisit"><a href="#/summary/visit/cumVisit">累计完成访视</a></Menu.Item>
                                                <Menu.Item key="/summary/visit/monVisit"><a href="#/summary/visit/monVisit">每月完成访视</a></Menu.Item>
                                            </SubMenu>
                                    }
                                    <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>FTE情况</span>}>
                                        <Menu.Item key="/summary/fte/cumFTE"><a href="#/summary/fte/cumFTE">累计FTE情况</a></Menu.Item>
                                        <Menu.Item key="/summary/fte/monFTE"><a href="#/summary/fte/monFTE">每月FTE情况</a></Menu.Item>
                                        <Menu.Item key="/summary/siteFTE"><a href="#/summary/siteFTE">各中心FTE情况</a></Menu.Item>
                                    </SubMenu>
                                    {
                                        !isUnBlind ?
                                            <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>数据分析</span>}>
                                                <Menu.Item key="/summary/preFilter/filterSource"><a href="#/summary/preFilter/filterSource">预筛来源统计</a></Menu.Item>
                                                <Menu.Item key="/summary/preFilter/filterReason"><a href="#/summary/preFilter/filterReason">预筛失败原因统计</a></Menu.Item>
                                                <Menu.Item key="/summary/filter"><a href="#/summary/filter">筛选失败原因统计</a></Menu.Item>
                                                <Menu.Item key="/summary/violation"><a href="#/summary/violation">方案违背分类统计</a></Menu.Item>
                                            </SubMenu>
                                        :
                                            <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>数据分析</span>}>
                                                <Menu.Item key="/summary/violation"><a href="#/summary/violation">方案违背分类统计</a></Menu.Item>
                                            </SubMenu>
                                    }
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目计划*/
                            !isUnBlind ?
                                auth('role', ['CTA', 'PA', 'PM', 'BO','CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                    <SubMenu title={<span><i className="icon iconfont">&#xe639;</i>项目计划</span>}>
                                        <Menu.Item key="/plan/degree"><a href="#/plan/degree">项目阶段进度计划</a></Menu.Item>
                                        <Menu.Item key="/plan/invStart"><a href="#/plan/invStart">项目启动计划</a></Menu.Item>
                                        <Menu.Item key="/plan/siteStart"><a href="#/plan/siteStart">各中心启动计划</a></Menu.Item>
                                        <Menu.Item key="/plan/investigation"><a href="#/plan/investigation">项目执行计划</a></Menu.Item>
                                        <Menu.Item key="/plan/site"><a href="#/plan/site">各中心执行计划</a></Menu.Item>
                                        <Menu.Item key="/plan/siteFte"><a href="#/plan/siteFte">各中心FTE计划</a></Menu.Item>
                                        <Menu.Item key="/plan/PmFte"><a href="#/plan/PmFte">PM-FTE计划</a></Menu.Item>
                                        <Menu.Item key="/plan/PAFte"><a href="#/plan/PAFte">PA-FTE计划</a></Menu.Item>
                                    </SubMenu>
                                )
                            :
                                auth('role', ['CTA', 'PA', 'PM', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML'], 1)(
                                    <SubMenu title={<span><i className="icon iconfont">&#xe639;</i>项目计划</span>}>
                                        {isShowInvPlan && <Menu.Item key="/plan/investigation"><a href="#/plan/investigation">项目执行计划</a></Menu.Item>}
                                        {isShowInvPlan && <Menu.Item key="/plan/site"><a href="#/plan/site">各中心执行计划</a></Menu.Item>}
                                        <Menu.Item key="/plan/siteFte"><a href="#/plan/siteFte">各中心FTE计划</a></Menu.Item>
                                        <Menu.Item key="/plan/PmFte"><a href="#/plan/PmFte">PM-FTE计划</a></Menu.Item>
                                        <Menu.Item key="/plan/PAFte"><a href="#/plan/PAFte">PA-FTE计划</a></Menu.Item>
                                    </SubMenu>
                                )
                        }
                        {
                            /* 研究中心*/
                            auth('role', ['CTA', 'PA', 'PM', 'BO', 'CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe6b2;</i>研究中心</span>}>
                                    <Menu.Item key="/site/detail"><a href="#/site/detail">研究中心信息</a></Menu.Item>
                                    <Menu.Item key="/site/pi"><a href="#/site/pi">参与临床试验人员信息</a></Menu.Item>
                                    <Menu.Item key="/site/cra"><a href="#/site/cra">CRA信息</a></Menu.Item>
                                    <Menu.Item key="/site/researchCenterCost"><a href="#/site/researchCenterCost">研究中心费用</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目成员*/
                            auth('role', ['CTA', 'PA', 'PM', 'BO', 'CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe73c;</i>项目成员</span>}>
                                    <Menu.Item key="/member/crc"><a href="#/member/crc">CRC信息</a></Menu.Item>
                                    <Menu.Item key="/member/require"><a href="#/member/require">人员需求</a></Menu.Item>
                                    <Menu.Item key="/member/distribution"><a href="#/member/distribution">人员分布</a></Menu.Item>
                                    <Menu.Item key="/member/staffEfficiency"><a href="#/member/staffEfficiency">人员效率</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目启动*/
                            !isUnBlind &&
                            auth('role', ['CTA', 'PA', 'PM', 'BO', 'CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe618;</i>项目启动</span>}>
                                    <Menu.Item key="/startUp/heredity"><a href="#/startUp/heredity">遗传办</a></Menu.Item>
                                    <Menu.Item key="/startUp/siteStart"><a href="#/startUp/siteStart">中心启动记录</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目执行运行端*/
                            auth('role', ['CTA', 'PA', 'PM', 'BO', 'CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                !isUnBlind ?
                                    <SubMenu title={<span><i className="icon iconfont">&#xe702;</i>项目执行</span>}>
                                        <Menu.Item key="/execute/visitPeriodPlan"><a href="#/execute/visitPeriodPlan">访视周期计划</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Pre_Filter"><a href="#/execute/crf/Type_Pre_Filter">预筛记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Filter"><a href="#/execute/crf/Type_Filter">筛选记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Visit"><a href="#/execute/crf/Type_Visit">访视记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drop"><a href="#/execute/crf/Type_Drop">退出记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Violation"><a href="#/execute/crf/Type_Violation">方案违背</a></Menu.Item>
                                        <Menu.Item key="/execute/importantEvent"><a href="#/execute/importantEvent">重大事件</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_SAE"><a href="#/execute/crf/Type_SAE">SAE记录</a></Menu.Item>
                                        <Menu.Item key="/execute/qa"><a href="#/execute/qa">Q&A记录</a></Menu.Item>
                                        <Menu.Item key="/execute/patients"><a href="#/execute/patients">病例数</a></Menu.Item>
                                        <Menu.Item key="/execute/standardVisitNum"><a href="#/execute/standardVisitNum">标准访视数</a></Menu.Item>
                                        <Menu.Item key="/execute/manHour"><a href="#/execute/manHour">项目工时</a></Menu.Item>
                                        <Menu.Item key="/execute/transfer"><a href="#/execute/transfer">项目交接</a></Menu.Item>
                                        {this.getTemplateNameList('execute')}
                                    </SubMenu>
                                :
                                    <SubMenu title={<span><i className="icon iconfont">&#xe702;</i>项目执行</span>}>
                                        <Menu.Item key="/execute/visitPeriodPlan"><a href="#/execute/visitPeriodPlan">访视周期计划</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Visit"><a href="#/execute/crf/Type_Visit">访视记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drop"><a href="#/execute/crf/Type_Drop">退出记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Violation"><a href="#/execute/crf/Type_Violation">方案违背</a></Menu.Item>
                                        <Menu.Item key="/execute/importantEvent"><a href="#/execute/importantEvent">重大事件</a></Menu.Item>
                                        <Menu.Item key="/execute/qa"><a href="#/execute/qa">Q&A记录</a></Menu.Item>
                                        <Menu.Item key="/execute/standardVisitNum"><a href="#/execute/standardVisitNum">标准访视数</a></Menu.Item>
                                        <Menu.Item key="/execute/manHour"><a href="#/execute/manHour">项目工时</a></Menu.Item>
                                        <Menu.Item key="/execute/transfer"><a href="#/execute/transfer">项目交接</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drug_Overtemperature"><a href="#/execute/crf/Type_Drug_Overtemperature">药物超温</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drug_Breakage"><a href="#/execute/crf/Type_Drug_Breakage">药物破损</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Instrument_Certificate"><a href="#/execute/crf/Type_Instrument_Certificate">仪器设备校准证书</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drug_Blindness"><a href="#/execute/crf/Type_Drug_Blindness">药物破盲</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drug_Inventory"><a href="#/execute/crf/Type_Drug_Inventory">药物库存量</a></Menu.Item>
                                        {this.getTemplateNameList('execute')}
                                    </SubMenu>
                            )
                        }
                        {
                            /* 项目关闭*/
                            !isUnBlind &&
                            auth('role', ['CTA', 'PA', 'PM', 'BO', 'CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe62c;</i>项目关闭</span>}>
                                    <Menu.Item key="/shutOff/siteClose"><a href="#/shutOff/siteClose">中心关闭记录</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目汇总*/
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'CRCC', 'CRCM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe6a7;</i>项目汇总</span>}>
                                    <Menu.Item key="/sumTotal/weeklySummary"><a href="#/sumTotal/weeklySummary">项目周汇总</a></Menu.Item>
                                    <Menu.Item key="/sumTotal/monthlySummary"><a href="#/sumTotal/monthlySummary">项目月汇总</a></Menu.Item>
                                    <Menu.Item key="/sumTotal/efficiency"><a href="#/sumTotal/efficiency">项目效率</a></Menu.Item>
                                    {!isCTA && <Menu.Item key="/sumTotal/percent"><a href="#/sumTotal/percent">项目完工百分比</a></Menu.Item>}
                                    {<Menu.Item key="/sumTotal/crcWeekly"><a href="#/sumTotal/crcWeekly">CRC周报</a></Menu.Item>}
                                    {
                                        (isPM || isBO || isCRCC || isCRCM || isCTA || isVP || isFIN || isPML) && <Menu.Item key="/sumTotal/crcQuarterScore"><a href="#/sumTotal/crcQuarterScore">CRC季度评分</a></Menu.Item>
                                    }
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目合同*/
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe64e;</i>项目合同</span>}>
                                    <Menu.Item key="/projectContract/contractRecord"><a href="#/projectContract/contractRecord">合同记录</a></Menu.Item>
                                    <Menu.Item key="/projectContract/requestRecord"><a href="#/projectContract/requestRecord">合同请款记录</a></Menu.Item>
                                    {(isPM || isBD || isBA || isTAL || isBAL || isPML || isCSA || isCSAL) && <Menu.Item key="/projectContract/returnedMoney"><a href="#/projectContract/returnedMoney">发票和回款记录</a></Menu.Item>}
                                    {(isPM || isBO || isCRCC || isCRCM || isTAL || isPML) && <Menu.Item key="/projectContract/applyJdeCode"><a href="#/projectContract/applyJdeCode">JDE建号申请记录</a></Menu.Item>}
                                    {(isPM) && <Menu.Item key="/projectContract/contractInfoChange"><a href="#/projectContract/contractInfoChange">合同信息变更申请</a></Menu.Item>}
                                    {(isPM || isBO || isCRCC || isCRCM || isTAL || isPML) && <Menu.Item key="/projectContract/alterJdeCode"><a href="#/projectContract/alterJdeCode">JDE主项目号变更申请</a></Menu.Item>}
                                    <Menu.Item key="/projectContract/terminationApply"><a href="#/projectContract/terminationApply">项目终止申请</a></Menu.Item>
                                    <Menu.Item key="/projectContract/costOfContractSplit"><a href="#/projectContract/costOfContractSplit">合同费用拆分</a></Menu.Item>
                                    {/* <Menu.Item key="/projectContract/endAgreement"><a href="#/projectContract/endAgreement">终止协议</a></Menu.Item> */}
                                </SubMenu>
                            )
                        }
                        {
                            !isUnBlind &&
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'CRCC', 'CRCM', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe888;</i>竞争公司表现</span>}>
                                    <Menu.Item key="/competeCompany/performance"><a href="#/competeCompany/performance">竞争公司表现</a></Menu.Item>
                                    <Menu.Item key="/competeCompany/compare"><a href="#/competeCompany/compare">津石与竞争公司对比</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            auth('role', ['BO', 'VP', 'PML', 'TAL', 'CSAL', 'CSA', 'PM', 'PA', 'CRC'], 1)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe691;</i>文件管理</span>}>
                                    <Menu.Item key="/fileManagement/projectFile"><a href="#/fileManagement/projectFile">项目文档</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目状态*/
                            auth('role', ['PM', 'PA', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'CRC', 'CRCC', 'CRCM', 'CTA', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 2)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe60d;</i>项目状态</span>}>
                                    {
                                        !isUnBlind ?
                                            <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>入组情况</span>}>
                                                <Menu.Item key="/summary/view/cumInfRan"><a href="#/summary/view/cumInfRan">累计知情随机(入组)</a></Menu.Item>
                                                <Menu.Item key="/summary/view/monInfRam"><a href="#/summary/view/monInfRam">每月知情随机(入组)</a></Menu.Item>
                                                <Menu.Item key="/summary/view/cumFilRan"><a href="#/summary/view/cumFilRan">累计筛选随机(入组)</a></Menu.Item>
                                                <Menu.Item key="/summary/view/monFilRan"><a href="#/summary/view/monFilRan">每月筛选随机(入组)</a></Menu.Item>
                                                <Menu.Item key="/summary/visit/cumVisit"><a href="#/summary/visit/cumVisit">累计完成访视</a></Menu.Item>
                                                <Menu.Item key="/summary/visit/monVisit"><a href="#/summary/visit/monVisit">每月完成访视</a></Menu.Item>
                                            </SubMenu>
                                        :
                                            <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>入组情况</span>}>
                                                <Menu.Item key="/summary/visit/cumVisit"><a href="#/summary/visit/cumVisit">累计完成访视</a></Menu.Item>
                                                <Menu.Item key="/summary/visit/monVisit"><a href="#/summary/visit/monVisit">每月完成访视</a></Menu.Item>
                                            </SubMenu>
                                    }
                                    <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>FTE情况</span>}>
                                        <Menu.Item key="/summary/fte/cumFTE"><a href="#/summary/fte/cumFTE">累计FTE情况</a></Menu.Item>
                                        <Menu.Item key="/summary/fte/monFTE"><a href="#/summary/fte/monFTE">每月FTE情况</a></Menu.Item>
                                    </SubMenu>
                                    {
                                        !isUnBlind ?
                                            <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>数据分析</span>}>
                                                <Menu.Item key="/summary/preFilter/filterSource"><a href="#/summary/preFilter/filterSource">预筛来源统计</a></Menu.Item>
                                                <Menu.Item key="/summary/preFilter/filterReason"><a href="#/summary/preFilter/filterReason">预筛失败原因统计</a></Menu.Item>
                                                <Menu.Item key="/summary/filter"><a href="#/summary/filter">筛选失败原因统计</a></Menu.Item>
                                                <Menu.Item key="/summary/violation"><a href="#/summary/violation">方案违背分类统计</a></Menu.Item>
                                            </SubMenu>
                                        :
                                            <SubMenu title={<span><i className="icon iconfont">&#xe675;</i>数据分析</span>}>
                                                <Menu.Item key="/summary/violation"><a href="#/summary/violation">方案违背分类统计</a></Menu.Item>
                                            </SubMenu>
                                    }
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目计划*/
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'CRC', 'CRCC', 'CRCM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 2)(
                                !isUnBlind ?
                                    <SubMenu title={<span><i className="icon iconfont">&#xe639;</i>项目计划</span>}>
                                        <Menu.Item key="/plan/siteStart"><a href="#/plan/siteStart">中心启动计划</a></Menu.Item>
                                        <Menu.Item key="/plan/site"><a href="#/plan/site">中心执行计划</a></Menu.Item> 
                                        <Menu.Item key="/plan/siteFte"><a href="#/plan/siteFte">中心FTE计划</a></Menu.Item>
                                    </SubMenu>
                                :
                                    <SubMenu title={<span><i className="icon iconfont">&#xe639;</i>项目计划</span>}>
                                        <Menu.Item key="/plan/siteFte"><a href="#/plan/siteFte">中心FTE计划</a></Menu.Item>
                                    </SubMenu>
                            )
                        }
                        {
                            /* 研究中心*/
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'CRC', 'CRCC', 'CRCM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 2)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe6b2;</i>研究中心</span>}>
                                    <Menu.Item key="/site/detail"><a href="#/site/detail">研究中心信息</a></Menu.Item>
                                    <Menu.Item key="/site/pi"><a href="#/site/pi">参与临床试验人员信息</a></Menu.Item>
                                    <Menu.Item key="/site/cra"><a href="#/site/cra">CRA信息</a></Menu.Item>
                                    <Menu.Item key="/site/researchCenterCost"><a href="#/site/researchCenterCost">研究中心费用</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目成员*/
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'CRC', 'CRCC', 'CRCM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 2)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe73c;</i>项目成员</span>}>
                                    <Menu.Item key="/member/crc"><a href="#/member/crc">CRC信息</a></Menu.Item>
                                    {
                                        !isCRC && <Menu.Item key="/member/require"><a href="#/member/require">人员需求</a></Menu.Item>
                                    }
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目启动*/
                            !isUnBlind &&
                            auth('role', ['CTA', 'PA', 'PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 2)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe618;</i>项目启动</span>}>
                                    <Menu.Item key="/startUp/heredity"><a href="#/startUp/heredity">遗传办</a></Menu.Item>
                                    <Menu.Item key="/startUp/siteStart"><a href="#/startUp/siteStart">中心启动记录</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目执行*/
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'CRC', 'CRCC', 'CRCM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 2)(
                                !isUnBlind ?
                                    <SubMenu title={<span><i className="icon iconfont">&#xe702;</i>项目执行</span>}>
                                        <Menu.Item key="/execute/visitPeriodPlan"><a href="#/execute/visitPeriodPlan">访视周期计划</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Pre_Filter"><a href="#/execute/crf/Type_Pre_Filter">预筛记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Filter"><a href="#/execute/crf/Type_Filter">筛选记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Visit"><a href="#/execute/crf/Type_Visit">访视记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drop"><a href="#/execute/crf/Type_Drop">退出记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Violation"><a href="#/execute/crf/Type_Violation">方案违背</a></Menu.Item>
                                        <Menu.Item key="/execute/importantEvent"><a href="#/execute/importantEvent">重大事件</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_SAE"><a href="#/execute/crf/Type_SAE">SAE记录</a></Menu.Item>
                                        <Menu.Item key="/execute/qa"><a href="#/execute/qa">Q&A记录</a></Menu.Item>
                                        <Menu.Item key="/execute/patients"><a href="#/execute/patients">病例数</a></Menu.Item>
                                        <Menu.Item key="/execute/standardVisitNum"><a href="#/execute/standardVisitNum">标准访视数</a></Menu.Item>
                                        <Menu.Item key="/execute/manHour"><a href="#/execute/manHour">项目工时</a></Menu.Item>
                                        <Menu.Item key="/execute/transfer"><a href="#/execute/transfer">项目交接</a></Menu.Item>
                                        {this.getTemplateNameList('execute')}
                                    </SubMenu>
                                :
                                    <SubMenu title={<span><i className="icon iconfont">&#xe702;</i>项目执行</span>}>
                                        <Menu.Item key="/execute/visitPeriodPlan"><a href="#/execute/visitPeriodPlan">访视周期计划</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Visit"><a href="#/execute/crf/Type_Visit">访视记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drop"><a href="#/execute/crf/Type_Drop">退出记录</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Violation"><a href="#/execute/crf/Type_Violation">方案违背</a></Menu.Item>
                                        <Menu.Item key="/execute/importantEvent"><a href="#/execute/importantEvent">重大事件</a></Menu.Item>
                                        <Menu.Item key="/execute/qa"><a href="#/execute/qa">Q&A记录</a></Menu.Item>
                                        <Menu.Item key="/execute/standardVisitNum"><a href="#/execute/standardVisitNum">标准访视数</a></Menu.Item>
                                        <Menu.Item key="/execute/manHour"><a href="#/execute/manHour">项目工时</a></Menu.Item>
                                        <Menu.Item key="/execute/transfer"><a href="#/execute/transfer">项目交接</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drug_Overtemperature"><a href="#/execute/crf/Type_Drug_Overtemperature">药物超温</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drug_Breakage"><a href="#/execute/crf/Type_Drug_Breakage">药物破损</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Instrument_Certificate"><a href="#/execute/crf/Type_Instrument_Certificate">仪器设备校准证书</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drug_Blindness"><a href="#/execute/crf/Type_Drug_Blindness">药物破盲</a></Menu.Item>
                                        <Menu.Item key="/execute/crf/Type_Drug_Inventory"><a href="#/execute/crf/Type_Drug_Inventory">药物库存量</a></Menu.Item>
                                        {this.getTemplateNameList('execute')}
                                    </SubMenu>
                            )
                        }
                        {
                            /* 项目关闭*/
                            !isUnBlind &&
                            auth('role', ['CTA', 'PA', 'PM', 'CRC', 'CRCC', 'CRCM', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 2)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe62c;</i>项目关闭</span>}>
                                    <Menu.Item key="/shutOff/siteClose"><a href="#/shutOff/siteClose">中心关闭记录</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                        {
                            /* 项目汇总*/
                            auth('role', ['CTA', 'PM', 'PA', 'BO', 'BD', 'BDO', 'TAL', 'BDM', 'CRC', 'CRCC', 'CRCM', 'VP', 'FIN', 'BA', 'BAL', 'PML', 'CSA', 'CSAL'], 2)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe6a7;</i>项目汇总</span>}>
                                    <Menu.Item key="/sumTotal/weeklySummary"><a href="#/sumTotal/weeklySummary">中心周汇总</a></Menu.Item>
                                    <Menu.Item key="/sumTotal/monthlySummary"><a href="#/sumTotal/monthlySummary">中心月汇总</a></Menu.Item>
                                    <Menu.Item key="/sumTotal/efficiency"><a href="#/sumTotal/efficiency">中心效率</a></Menu.Item>
                                    {
                                        <Menu.Item key="/sumTotal/crcWeekly"><a href="#/sumTotal/crcWeekly">CRC周报</a></Menu.Item>
                                    }
                                </SubMenu>
                            )
                        }
                        {
                            auth('role', ['CRC'], 2)(
                                <SubMenu title={<span><i className="icon iconfont">&#xe691;</i>文件管理</span>}>
                                    <Menu.Item key="/fileManagement/projectFile"><a href="#/fileManagement/projectFile">项目文档</a></Menu.Item>
                                </SubMenu>
                            )
                        }
                    </Menu>
                </div>
            </nav>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        menuAuth: state.menuState.menuAuth || {},
        selectItem: state.templateState.selectItem || {},
        templateList: state.templateState.list || [],
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveMenuAuth: list => dispatch(saveMenuAuth(list)),
        templateItemCreator: item => dispatch(saveTemplateItem(item)),
        templateListCreator: list => dispatch(saveTemplateList(list)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Nav);


// WEBPACK FOOTER //
// ./src/components/layout/Nav.js